import { FiCheck } from '@/components/react-icons/main';
import IconV2 from '@/components/v2/IconV2';
import { useRef, useEffect } from 'react';

const WizardRadio = ({ value, checked, onChange, label, description, type = 'radio', icon, autoFocus = false, ...props }) => {
  const radioRef = useRef(null);

  useEffect(() => {
    if (autoFocus && radioRef.current) {
      radioRef.current.focus();
    }
  }, [autoFocus]);

  const handleClick = () => {
    if (onChange) {
      onChange(value);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  const isCheckbox = type === 'checkbox';

  return (
    <div ref={radioRef} className={`comp-wizard-radio ${checked ? 'selected' : ''} ${isCheckbox ? 'checkbox-type' : ''}`} onClick={handleClick} onKeyDown={handleKeyDown} tabIndex={0} role="radio" aria-checked={checked} {...props}>
      <div className={`comp-wizard-radio-header ${!description ? 'centered' : ''}`}>
        {isCheckbox ? (
          <div className={`checkbox-wrapper ${checked ? 'checked' : ''}`} aria-checked={checked} role={'checkbox'}>
            <IconV2 icon={FiCheck} />
          </div>
        ) : (
          <div className="comp-wizard-radio-button">{checked && <div className="comp-wizard-radio-button-dot" />}</div>
        )}
        <span className="comp-wizard-radio-label">{label}</span>
        {icon && <IconV2 icon={icon} className="comp-wizard-radio-icon" />}
      </div>
      {description && <p className="comp-wizard-radio-description">{description}</p>}
    </div>
  );
};

export default WizardRadio;
